import { Controller } from "stimulus"
import $ from 'jquery';
import Inputmask from "inputmask";

export default class extends Controller {
    initialize() {
        Inputmask().mask(document.querySelectorAll("input"));
    }
}